
define("rv!templates/partials/star",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:7,
          e:"img",
          a:{ alt:"star",
            src:"https://adestinn2blob.blob.core.windows.net/images/full-star.svg" } } ],
      n:52,
      r:"." } ] };});
